import React from 'react';
import { observer } from 'mobx-react';
import userDetail from 'Stores/userDetail';
import commonAppData from 'Stores/commonAppData';
import Utils from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import { ReactComponent as SearchIcon } from 'Assets/svg/open-search.svg';
import { paidUserTechnologyFilterPopupState } from 'Components/common/paidUserTechnologyFilterPopup';
import { InputBoxWithSuggestion } from '../shared-component/inputBoxWithSuggestion';

let cancelTechnologiesCall = null;

const Technologies = observer(props => {
  const suggestionKey = 'technologies';
  const [inputVal, setInputVal] = React.useState('');
  const [suggestionList, setSuggestionList] = React.useState([]);
  const [selectedItem, setSelectedItem] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [noMatchFound, setNoMatchFound] = React.useState(false);

  const { featureFlags } = userDetail;
  const { TECHNOLOGY_FILTER = false } = featureFlags;

  const generateListSearchArr = list => {
    const newList = list.map(item => {
      const { id } = item;
      const newObj = {};
      newObj.pName = id;
      newObj.orgName = id;
      newObj.name = id;
      return newObj;
    });

    setSuggestionList(newList);
  };

  const getSuggestion = async () => {
    try {
      if (cancelTechnologiesCall !== null) {
        cancelTechnologiesCall('cancel');
        cancelTechnologiesCall = null;
      }
      const technologiesCancelCallback = value => {
        cancelTechnologiesCall = value;
      };
      setLoading(true);
      const response = await commonAppData.getTechnologiesSuggestions(
        inputVal,
        technologiesCancelCallback,
      );
      setLoading(false);

      if (response && response.data) {
        const { suggestions } = response.data;
        generateListSearchArr(suggestions);
        if (suggestions && suggestions.length === 0) setNoMatchFound(true);
      }
    } catch (error) {
      setLoading(false);
      console.log('Industry auto complete error', error);
    }
  };

  const handleLockFilter = e => {
    const { userInfo } = userDetail;
    const { userStatus, email } = userInfo;
    if (userStatus === 0)
      if (Utils.isPaidUser()) {
        Utils.mixpanelTrack(
          CONSTANTS.MX_AS_EVENTS.LB_AS_TECHNOLOGY_FILTER_POPUP_VIEW,
          { actionEvent: 'click' },
        );
        paidUserTechnologyFilterPopupState.setShowPopup(true);
      } else {
        Utils.showFreeTrialPopup(true, 'filters', false, true);
      }
    else Utils.showEmailConfirmationPopup(email);
  };

  React.useEffect(() => {
    setNoMatchFound(false);
    if (inputVal === '') {
      if (cancelTechnologiesCall !== null) {
        cancelTechnologiesCall('cancel');
        cancelTechnologiesCall = null;
      }
      setSuggestionList(commonAppData.technologiesFilterInitialData);
    } else {
      getSuggestion();
    }
  }, [inputVal]);

  React.useEffect(() => {
    if (inputVal === '')
      setSuggestionList(commonAppData.technologiesFilterInitialData);
  }, [commonAppData.technologiesFilterInitialData]);

  return TECHNOLOGY_FILTER ? (
    <InputBoxWithSuggestion
      inputVal={inputVal}
      placeholder="Technology"
      setInputVal={setInputVal}
      suggestionList={suggestionList}
      noMatchFound={noMatchFound}
      setNoMatchFound={setNoMatchFound}
      setSelectedItem={setSelectedItem}
      selectedItem={selectedItem}
      suggestionKey={suggestionKey}
      // showNewFlag
      {...props}
    />
  ) : (
    <div
      className="input-section placeholder-input-section"
      onClick={handleLockFilter}
    >
      <div className="input-box input-box-placehoder">Technology</div>
      <SearchIcon className="dropdown-icon plus-icon" width={14} height={14} />
      {/* <span className="new-feature-text">new</span> */}
    </div>
  );
});

export { Technologies };
export default Technologies;
